import React from "react"
import Avatar from "../../../components/Avatar"
import IconButton from "../../../components/IconButton"

const AdministradorListaColunas = (remover, setModalOpened) => [
  {
    dataField: "nome",
    text: "Nome",
    sort: true,
  },
  {
    dataField: "menu",
    isDummyField: true,
    text: "",
    formatter: (cellContent, item) => (
      <ul className="list-inline font-size-20 contact-links mb-0" style={{ textAlign: "right" }}>
        <li className="list-inline-item dropdown">
          <IconButton className="btn-warning btn-sm" style={{ marginRight: 10 }} onClick={() => { setModalOpened(item) }}>
            <i className="uil uil-edit"></i>
          </IconButton>
          <IconButton className="btn-danger btn-sm" onClick={() => { remover(item) }}>
            <i className="uil uil-trash"></i>
          </IconButton>
          {/* <IconButton className="btn-dark btn-sm" onClick={() => { setModalOpened(item) }} style={{ marginLeft: 5 }}>
            <i className="uil uil-edit"></i>
          </IconButton> */}
        </li>
      </ul>
    ),
  },
]

export default AdministradorListaColunas